export default __webpack_public_path__ + "3e18588189133e64239f9881175823f1.png";